module.exports = __webpack_public_path__ + "media/images/details__prizeBox__stretch__second-84c4ec35d9f5de04141f134a2d078e55.png";